import { inferAdditionalFields, twoFactorClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

// Use relative URL — nginx proxies /api/auth to the API server.
// This keeps auth cookies same-origin (avoids third-party cookie blocking).
export const authClient = createAuthClient({
	baseURL: window.location.origin,
	plugins: [
		inferAdditionalFields({
			user: {
				role: { type: "string" },
				twoFactorMethod: { type: "string" },
				onboardedAt: { type: "date" },
				// twoFactorEnabled is added by the 2FA plugin schema; repeat it
				// here so it surfaces on the React session type.
				twoFactorEnabled: { type: "boolean" },
			},
		}),
		twoFactorClient({
			// When login succeeds but 2FA is required, navigate the browser to
			// the challenge page. Full page reload keeps router state simple.
			onTwoFactorRedirect: () => {
				const next = encodeURIComponent(window.location.pathname);
				window.location.href = `/two-factor?next=${next}`;
			},
		}),
	],
});

export const { signIn, signUp, signOut, useSession } = authClient;
